import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FacultySecretaries = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/yonetim/fakulte-sekreteri');
  }, [navigate]);

  return null; // or a loading spinner
};

export default FacultySecretaries; 